import {intlShape, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import {pick} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {Form} from 'react-bootstrap';
import {injectIntl} from 'react-intl';

import styles from './MultiLineBox.less';
import {I18N as I18NTextBox} from './TextBox';
import stylesAutoLayout from '../AutoLayout.less';
import {MULTI_LINE_BOX_ROWS_DEFAULT} from 'src/js/containers/auto_layout/auto_layout_constants';
import AutoLayoutService from 'src/js/lib/auto_layout/auto_layout_service';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {
  LayoutProperty,
  KEYWORD_DEFAULT_COMPONENT_NUM_LINES,
} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';
import {KEYWORD_PROP_CONTENT_VALUE} from 'src/js/model/auto_layout_screen_data_helpers';

class MultiLineBox extends React.PureComponent {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const {onDataChange} = this.props;
    onDataChange(this.getOnDataChangeData(e.target.value));
  }

  getOnDataChangeData(newData) {
    const {label} = this.props;
    return {
      ...pick(this.props, ['pathToData', 'data']),
      label,
      newData: {[KEYWORD_PROP_CONTENT_VALUE]: newData},
    };
  }

  getTextOnlyValue() {
    const {data, intl} = this.props;
    return data &&
      data[KEYWORD_PROP_CONTENT_VALUE] &&
      data[KEYWORD_PROP_CONTENT_VALUE] !== ''
      ? data[KEYWORD_PROP_CONTENT_VALUE]
      : utils.TranslateUtils.translate(I18NTextBox.EMPTY_DATA, intl);
  }

  render() {
    const {
      data,
      hasError,
      idSuffix,
      inputName,
      isReadOnly,
      isTextOnly,
      layout,
      screenId,
    } = this.props;
    const numLines =
      layout.getDefaultComponent()[KEYWORD_DEFAULT_COMPONENT_NUM_LINES] ||
      MULTI_LINE_BOX_ROWS_DEFAULT;
    const textOnlyValue = this.getTextOnlyValue();
    return isTextOnly ? (
      <span
        className={classNames(
          stylesAutoLayout.dlScreenComponentInput,
          stylesAutoLayout.dlMultiLineText
        )}
        title={textOnlyValue}
      >
        {textOnlyValue}
      </span>
    ) : (
      <Form.Control
        name={inputName}
        id={AutoLayoutService.getComponentId(screenId, inputName, idSuffix)}
        as='textarea'
        className={classNames(
          styles.dlTextAreaInput,
          stylesAutoLayout.dlScreenComponentInput,
          styles.dlVResize,
          {[stylesAutoLayout.dlValidationError]: hasError}
        )}
        rows={numLines}
        spellCheck={'false'}
        value={data[KEYWORD_PROP_CONTENT_VALUE] || ''}
        cols={'50'}
        disabled={isReadOnly}
        onChange={this.handleChange}
      />
    );
  }
}

MultiLineBox.displayName = 'MultiLineBox';

/* eslint-disable react/no-unused-prop-types */
MultiLineBox.propTypes = {
  content: PropTypes.instanceOf(ContentProperty).isRequired,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  isReadOnly: PropTypes.bool,
  isTextOnly: PropTypes.bool,
  inputName: PropTypes.string,
  intl: intlShape.isRequired,
  label: PropTypes.string,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
};

MultiLineBox.defaultProps = {
  data: {},
  idSuffix: '',
  pathToData: '',
  isReadOnly: false,
  isTextOnly: false,
  inputName: '',
  label: '',
  expanded: false,
  hasError: false,
};

export default injectIntl(MultiLineBox);
